{
    "AgentList_AddButton_DisabledTooltip": "Veuillez sélectionner un serveur de téléphonie et une partition dans les filtres ci-dessus pour ajouter un agent.",
    "AgentList_Column_AgentNumber": "Numéro d'agent",
    "AgentList_Column_PartitionId": "ID de partition",
    "AgentList_Column_Monitored": "surveillé",
    "AgentList_Monitored_Yes": "Oui",
    "AgentList_Monitored_No": "Non",
    "AgentList_Column_Description": "Description",
    "AgentList_Column_InternalNumber": "Numéro interne",
    "AgentList_Column_PartitionName": "Nom de la partition",
    "AgentList_Column_OmniChannel": "Omnicanal",
    "NAME": "Liste des agentsLangue"
}